import PropTypes from 'prop-types';
import * as ALOOMA from 'consts/alooma';
import Modal from 'components/templates/Modal/Modal';
import ModalBodyPartnershipsHubspotForm from 'components/molecules/ModalBodyPartnershipsHubspotForm/ModalBodyPartnershipsHubspotForm';

const ModalPartnershipsHubspotForm = props => {
  const { closeModal } = props;

  return (
    <Modal source={ALOOMA.SOURCE_PAGES.PARTNERSHIPS_HUBSPOT_FORM} onClose={closeModal}>
      <ModalBodyPartnershipsHubspotForm {...props} />
    </Modal>
  );
};

ModalPartnershipsHubspotForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ModalPartnershipsHubspotForm;
